import i18n from "../locales/i18n";

export default {
  folder: {
    en: i18n.t("limit.folder"),
  },
  file_size: {
    en: i18n.t("limit.file_size"),
  },
  list: {
    en: i18n.t("limit.list"),
  },
  chat: {
    en: i18n.t("limit.chat"),
  },
  team: {
    en: i18n.t("limit.team"), // This number change
  },
  task: {
    en: i18n.t("limit.task"),
  },
  subtask: {
    en: i18n.t("limit.subtask"),
  },
  section: {
    en: i18n.t("limit.section"),
  },
};
